// extracted by mini-css-extract-plugin
export default {"addToCartControl":"R1-z","giftCard":"S1-z","btnContainer":"T1-z","cartButton":"U1-z","disabled":"V1-z"};